import React, { Component } from "react";
import { withRouter } from "../common/with-router";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Breadcrumb from "react-bootstrap/Breadcrumb";

class Contact extends Component {
  render() {

    return (
      <div class="mt-4">
        <Breadcrumb>
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Contato</Breadcrumb.Item>
        </Breadcrumb>
        <h4>
          Quer levar a tecnologia de replays profissionais para seus jogos ou eventos?
        </h4>
          <Row>
            <Col className="col-12 col-md-10 col-lg-8">
              <div>
                Na Replay Pro, transformamos partidas em experiências memoráveis com nossa solução completa de gravação,
                transmissão e replay esportivo. Seja para clubes, academias, torneios ou atletas, oferecemos:
                <ul class="contact-list mt-2">
                  <li>
                    <strong>Instalação profissional de câmeras</strong> em quadras, campos ou ginásios
                  </li>
                  <li>
                    <strong>Plataforma online</strong> para acesso fácil aos vídeos e replays
                  </li>
                  <li>
                    <strong>Ferramentas de análise</strong> para acompanhar visualizações, engajamento e público-alvo
                  </li>
                  <li>
                    <strong>Transmissão ao vivo</strong> para seu torneio, campeonato ou evento alcançar o mundo
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="col-12 col-md-10 col-lg-8">
              <h5 class="mt-4 mb-2">Solicite um Orçamento ou Proposta Personalizada</h5>
              <div>
                Envie um e-mail para <a href="mailto:contato@replaypro.com.br">contato@replaypro.com.br</a> informando
                qual o seu interesse e o seu contato (whatsapp de preferência) que nosso time irá te chamar para conversar.
              </div>
            </Col>
          </Row>
      </div>
    );
  }
}

export default withRouter(Contact);